import React, { useEffect, useState } from "react";
import "../CSS/Home.css";
import clglogo from "../Assests/footerminilogo.png";
import img from "../Assests/ece-symp.png";

const HeroSection = () => {
  const [timeLeft, setTimeLeft] = useState("");

  const calculateTimeLeft = () => {
    const endTime = new Date("2025-04-17T09:00:00");
    const now = new Date();
    const diff = endTime - now;

    if (diff <= 0) {
      setTimeLeft("Event Started!");
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / 1000 / 60) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
  };

  useEffect(() => {
    const timer = setInterval(calculateTimeLeft, 1000);

    const strikeInterval = setInterval(() => {
      const strike = document.getElementById("thunder-strike");
      if (strike) {
        strike.style.opacity = 0.6;
        strike.style.transform = "scale(1)";
        setTimeout(() => {
          strike.style.opacity = 0;
          strike.style.transform = "scale(0.8)";
        }, 200);
      }
    }, Math.random() * 7000 + 3000);

    return () => {
      clearInterval(timer);
      clearInterval(strikeInterval);
    };
  }, []);

  return (
    <section className="hero" id="home">
      <div className="hero-light" id="thunder-strike"></div>
      <div className="hero-left">
        <img src={clglogo} alt="College Logo" className="college-logo" />
        <h1>NEHRU INSTITUTE OF ENGINEERING AND TECHNOLOGY</h1>
        <h3>Department of Electronics and Communication Engineering</h3>
        <h2>
          VIGNAN <span className="highlight">2K25</span>
        </h2>
        <p className="tagline">"Innovate, Compete, Conquer!"</p>
        <div className="countdown">Starts In: <span>{timeLeft}</span></div>
        <a href="https://forms.gle/RH16qNgFAhEcbJ8x5" className="register-btn">Register Now</a>
      </div>
      <div className="hero-right">
        <div className="image-container">
          <img src={img} alt="Student" className="student-img" />
          <div className="badge top">8+<br /><span>EVENTS</span></div>
          <div className="badge bottom">4+<br /><span>TECH EVENTS</span></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;